angular.module('tgaAdmin').directive('stFilteredCollection', () => ({
  restrict: 'A',
  require: '^stTable',
  scope: {
    stFilteredCollection: '=',
  },
  link(scope, element, attr, ctrl) {
    scope.$watch(() => ctrl.getFilteredCollection(), () => {
      scope.stFilteredCollection = ctrl.getFilteredCollection();
    });
  },
}));
